export * from './getRootWindow';
